import React from 'react';
import Link from 'react-router/lib/Link';
import './ServiceMenu.less';

function Item({data: {key, title}, parent, selected}) {
  const url = `/service/${parent}/${key}`;
  return (
    <div data-role='Item' data-selected={selected === key ? true : null}>
      <Link to={url}>{title}</Link>
    </div>
  );
}

function Group({data: {key, title, children}, selected, open, onOpen}) {
  const opened = open.includes(key) ? true : null;
  const onClick = () => {
    if (opened) {
      onOpen(open.filter(openKey => openKey !== key));
    } else {
      onOpen(open.concat([key]));
    }
  };
  return (
    <div data-role='Group' data-opened={opened}>
      <div onClick={onClick}>
        <img src={`/imgs/service/arrow-${opened ? 'down' : 'right'}.png`}/>
        <span>{title}</span>
      </div>
      <div>
        {children.map((item, index) => <Item key={index} data={item} parent={key} selected={selected}/>)}
      </div>
    </div>
  );
}

function ServiceMenu({title, menu, open, selected, onOpen}) {
  return (
    <div className='ServiceMenu'>
      <h1>{title}</h1>
      <div>{menu.map((item, index) => <Group {...{selected, open, onOpen, data: item, key: index}} />)}</div>
    </div>
  );
}

class ServiceMenuContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {open: [props.nav1]};
  }

  render() {
    const {title, menu, nav2} = this.props;
    const props = {
      title,
      menu,
      selected: nav2,
      open: this.state.open,
      onOpen: (open) => this.setState({open})
    };
    return <ServiceMenu {...props} />;
  }
}

export default ServiceMenuContainer;


// WEBPACK FOOTER //
// ./src/routes/Service/ServiceMenu.js